<div class="merchant-no-access" data-cy="merchant-no-access">
  <p class="merchant-no-access-message" data-cy="merchant-no-access-message">
    {{ 'MerchantNoAccessMessage' | translate : { user: representativeName, merchant: (merchantName$ | async) } }}
  </p>
</div>
